import { render, staticRenderFns } from "./ServiceWorkList.vue?vue&type=template&id=4ea24f0e&"
import script from "./ServiceWorkList.vue?vue&type=script&lang=js&"
export * from "./ServiceWorkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports